import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import LoadingSpinner from './LoadingSpinner';
import MyEvents from '../pages/MyEvents';
import { getMyEventsUrlParams } from '../utils/myEventsUrlParams';

const guestLinkErrorStyles = {
  centerPage: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px',
    background: '#18181b',
  },
  card: {
    maxWidth: '420px',
    padding: '24px',
    borderRadius: '12px',
    background: '#27272a',
    color: '#f8fafc',
    textAlign: 'center',
  },
  title: {
    margin: '0 0 12px',
    fontSize: '1.2rem',
  },
  errorText: {
    margin: 0,
    color: 'rgba(255, 255, 255, 0.7)',
    lineHeight: 1.5,
  },
};

const MyEventsRoute = ({ userData, setUserData, PrivateRoute }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [guestLinkError, setGuestLinkError] = useState('');
  const { tempLinkId, presentKiosk } = getMyEventsUrlParams(location.search);

  useEffect(() => {
    if (!tempLinkId) return undefined;

    const existingToken = localStorage.getItem('token');
    if (existingToken) {
      navigate(presentKiosk ? '/my-events?command=present' : '/my-events', { replace: true });
      return undefined;
    }

    let cancelled = false;

    (async () => {
      try {
        const response = await axios.post('/api/temp-links/guest-present/exchange', { link: tempLinkId });
        if (cancelled) return;

        localStorage.setItem('token', response.data.token);
        if (response.data.user) {
          setUserData(response.data.user);
        }

        const openPresent = response.data.presentKiosk !== false;
        navigate(openPresent ? '/my-events?command=present' : '/my-events', { replace: true });
      } catch (err) {
        if (cancelled) return;
        if (err.response?.status === 403 && err.response?.data?.code === 'ACCOUNT_INACTIVE') {
          navigate('/account-inactive', { replace: true });
          return;
        }
        setGuestLinkError(err.response?.data?.error || 'Unable to open guest Present link.');
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [tempLinkId, presentKiosk, navigate, setUserData]);

  if (tempLinkId) {
    if (guestLinkError) {
      return (
        <div style={guestLinkErrorStyles.centerPage}>
          <div style={guestLinkErrorStyles.card}>
            <h1 style={guestLinkErrorStyles.title}>Guest link unavailable</h1>
            <p style={guestLinkErrorStyles.errorText}>{guestLinkError}</p>
          </div>
        </div>
      );
    }

    return (
      <div style={guestLinkErrorStyles.centerPage}>
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <PrivateRoute>
      <MyEvents userData={userData} />
    </PrivateRoute>
  );
};

export default MyEventsRoute;
